<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport="true"
               [attr.role]="'navigation'"
               mode="'side'"
               opened="false">
    <a *ngIf="!drawer.opened" class="dropdown-item" (click)="drawer.toggle()">
      <div class="row">
        <div class="col-2">
          <i class="fas fa-bars fa-lg" title="Menu"></i>
        </div>
        <div class="col-10"></div>
      </div>
    </a>
    <br>
    <mat-toolbar>
      <div *ngIf="drawer.opened" class="col text-center">
        <i class="material-icons align-middle">wb_sunny</i>
        <mat-slide-toggle class="mx-2" (toggleChange)="onThemeChange()" [checked]="isDarkTheme"></mat-slide-toggle>
        <i class="material-icons align-middle">brightness_3</i>
      </div>
    </mat-toolbar>
    <div *ngIf="user" class="profile-card">
      <div class="navigation-item-label">
        <div class="header">
          <h3>{{ user.first_name }} {{ user.last_name }}</h3>
          <h4 style="color: grey">{{ user.company }}</h4>
        </div>
        <app-user-picture></app-user-picture>
      </div>
    </div>
    <mat-nav-list class="navigation-list">
      <app-navigation-item color="rgb(145,145,145)" link="/home" icon="fas fa-home fa-lg" title="Home" [details]="drawer.opened">Home</app-navigation-item>

      <app-navigation-item [disabled]="clusterList==undefined || clusterList.length==0" color="rgb(118,168,255)" link="/tools/dashboard" icon="fas fa-th-large fa-lg" title="Dashboard" [details]="drawer.opened">Dashboard</app-navigation-item>
      <app-navigation-item color="rgb(118,168,255)" link="/tools/my-portfolio" icon="fab fa-elementor fa-lg" title="My Portfolio" [details]="drawer.opened">My Portfolio</app-navigation-item>
      <app-navigation-item [disabled]="currentCluster==undefined || (currentCluster.is_standalone && !currentCluster.has_investable)" color="rgb(118,168,255)" link="/tools/analytics" icon="fas fa-chart-bar fa-lg" title="Analytics" [details]="drawer.opened">Analytics</app-navigation-item>
      <app-navigation-item [disabled]="currentCluster==undefined || !currentCluster.has_default_strategies || currentCluster.has_investable" color="rgb(118,168,255)" link="/tools/strategy-builder" icon="fas fa-boxes fa-lg" title="Strategy Builder" [details]="drawer.opened">Strategy Builder</app-navigation-item>
      <app-navigation-item [disabled]="currentCluster==undefined || !currentCluster.has_strategy || currentCluster.has_protected" color="rgb(118,168,255)" link="/tools/investable-solution" icon="fas fa-magic fa-lg" title="Investment Solution" [details]="drawer.opened">Investment Solution</app-navigation-item>
      <app-navigation-item [disabled]="currentCluster==undefined || !currentCluster.has_investable || currentCluster.has_update" color="rgb(118,168,255)" link="/tools/risk-management" icon="fab fa-buffer fa-lg" title="Risk Management" [details]="drawer.opened">Risk Management</app-navigation-item>
      <app-navigation-item [disabled]="currentCluster==undefined || !currentCluster.has_update" color="rgb(118,168,255)" link="/tools/position-keeping" icon="fas fa-hand-holding-usd fa-lg" title="Position Keeping" [details]="drawer.opened">Position Keeping</app-navigation-item>

      <app-navigation-item color="rgb(145,145,145)" icon="fas fa-sign-out-alt fa-lg" title="Sign out" [details]="drawer.opened" (click)="onSignOut()">Sign out</app-navigation-item>
    </mat-nav-list>
<!--
    <br>
    <mat-divider *ngIf="drawer.opened"></mat-divider>
    <br>

    <div class="navigation-item-label mx-5">
      <h3 class="card-text">Current Portfolio</h3>
      <p class="card-text">Returns</p>
      <div class="row card-text">
        <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
        <div class="col-6"> <mdb-badge color="success-color">15.7%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
        <div class="col-6"> <mdb-badge color="success-color">16.8%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
        <div class="col-6"> <mdb-badge color="success-color">12.3%</mdb-badge> </div>
      </div>
      <br>
      <p class="card-text">Volatility</p>
      <div class="row card-text">
        <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
        <div class="col-6"> <mdb-badge color="primary-color">12.7%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
        <div class="col-6"> <mdb-badge color="primary-color">13.1%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
        <div class="col-6"> <mdb-badge color="primary-color">10.3%</mdb-badge> </div>
      </div>
      <br>
      <p class="card-text">Market Exposure</p>
      <div class="row card-text">
        <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
        <div class="col-6"> <mdb-badge color="primary-color">97.7%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
        <div class="col-6"> <mdb-badge color="primary-color">96.5%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
        <div class="col-6"> <mdb-badge color="primary-color">69.7%</mdb-badge> </div>
      </div>
      <br>
      <p class="card-text">Conditional Performance</p>
      <div class="row card-text">
        <div class="col-6 card-text" style="color: rgb(227,143,72);"> Original </div>
        <div class="col-6"> <mdb-badge color="success-color">7.8%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(129,186,241)"> Investable </div>
        <div class="col-6"> <mdb-badge color="success-color">8.9%</mdb-badge> </div>
        <div class="col-6 card-text" style="color: rgb(94,187,75)"> Protected </div>
        <div class="col-6"> <mdb-badge color="success-color">6.7%</mdb-badge> </div>
      </div>
      <br><br><br><br>
    </div>
-->
  </mat-sidenav>

  <mat-sidenav-content class="sidenav-content py-0">
    <app-header [shrinkOffset]="true"></app-header>
    <app-dashboard *ngIf="selectedTab=='dashboard'"></app-dashboard>
    <app-my-portfolio *ngIf="selectedTab=='my-portfolio'"></app-my-portfolio>
    <app-analytics *ngIf="selectedTab=='analytics'"></app-analytics>
    <app-strategy-builder *ngIf="selectedTab=='strategy-builder'"></app-strategy-builder>
    <app-investable-solution *ngIf="selectedTab=='investable-solution'"></app-investable-solution>
    <app-risk-management *ngIf="selectedTab=='risk-management'"></app-risk-management>
    <app-position-keeping *ngIf="selectedTab=='position-keeping'"></app-position-keeping>
    <br>
  </mat-sidenav-content>
</mat-sidenav-container>
